import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-location-schedule',
    templateUrl: './location-schedule.component.html',
    styleUrls: ['./location-schedule.component.css'],
    standalone: false
})
export class LocationScheduleComponent implements OnInit {
  @Input() locationId!: string;

  constructor() { }

  ngOnInit(): void {
  }
}
